<template>
  <a
    v-if="searchReferrerRoute"
    role="button"
    :href="`${searchReferrerRoute.fullPath}`"
    class="summary-bar-action"
    @click.stop.prevent="backToResults"
  >
    <div class="back-button">
      <img src="@/assets/images/down-rounded.svg" width="16" height="9" />
    </div>
    <translate tag="p">Back to results</translate>
  </a>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { Route } from '../../../apps/pu-links/domain/Route'

@Component
class SearchSummaryBarAction extends Vue {
  @Prop({ default: null })
  searchReferrerRoute: Route | null

  @Prop({ default: false, type: Boolean })
  showEdit: boolean

  @Prop({ default: false, type: Boolean })
  hasDates: boolean

  @Prop({ required: false })
  ptsViewed: number

  backToResults() {
    const stepsToGoBack = this.ptsViewed * 2 + 1
    this.$router.go(-stepsToGoBack)
  }
}

export default toNative(SearchSummaryBarAction)
</script>
<style scoped>
.summary-bar-action {
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: center;
  padding: 0.25em 1em;
  text-decoration: none;
}

.summary-bar-action p {
  color: var(--colour-text-default);
  font-size: var(--small);
  line-height: 1;
  text-decoration: none;
}

.summary-bar-action img {
  width: 1.3em;
  height: auto;
  margin-right: 0.4em;
}

.summary-bar-action:active {
  background-color: #a0abb8;
}

.back-button img {
  transform: rotate(90deg);
  margin: 0;
}

.back-button {
  width: 1.4em;
  margin-right: 0.2em;
}

a:hover,
a:active {
  text-decoration: none;
}
</style>
